<template>
  <vxe-grid
    ref="table"
    auto-resize
    highlight-hover-row
    :data="v_tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="height"
    row-id="shipmentBatchBoxCode"
    size="mini"
    resizable
    border
    :checkbox-config="{
      highlight: true,
      range: true,
    }"
    :sort-config="{
      multiple: true,
      trigger: 'cell',
      chronological: true,
      defaultSort: [
        { field: 'contractNo', order: 'asc' },
        { field: 'retailerPo', order: 'asc' },
        { field: 'importerPo', order: 'asc' },
        { field: 'orderGoodsItemNo', order: 'asc' },
      ],
    }"
    @checkbox-range-change="onCheckboxChange"
    @checkbox-change="onCheckboxChange"
    @checkbox-all="onCheckboxChange"
    :edit-config="{
      trigger: 'click',
      mode: 'cell',
    }"
    @edit-closed="onEditClosed"
  >
    <template v-slot:top>
      <slot name="header"></slot>
    </template>
    <template #bottom>
      <slot name="footer"></slot>
    </template>
    <template v-slot:boxPriceAmount="{ row }">
      <span>{{ row.boxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
    </template>
    <template v-slot:boxSalePriceAmount="{ row }">
      <span>
        {{ row.boxSalePriceAmount || 0 }} {{ row.v_salesCurrencyUnit }}
      </span>
    </template>
    <template v-slot:deliveryTypeHeader>
      <filter-content
        :text="$l('INDEX.table_label_deliveryType') || '出货方式'"
        :items="deliveryTypeOptions"
        @filter="(e) => (deliveryTypeFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:contractNoHeader>
      <filter-content
        :text="$l('INDEX.table_label_contractNo') || '合同号'"
        :items="contractNoOptions"
        @filter="(e) => (contractNoFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:retailerPoHeader>
      <filter-content
        :text="$l('INDEX.table_label_retailerPo') || '零售商PO'"
        :items="retailerPoOptions"
        @filter="(e) => (retailerPoFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:importerPoHeader>
      <filter-content
        :text="$l('INDEX.table_label_importerPo') || '进口商PO'"
        :items="importerPoOptions"
        @filter="(e) => (importerPoFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:orderGoodsItemNoHeader>
      <filter-content
        :text="$l('INDEX.table_label_orderGoodsItemNo') || 'Item No'"
        :items="orderGoodsItemNoOptions"
        @filter="(e) => (orderGoodsItemNoFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:dispatchPortHeader>
      <filter-content
        :text="$l('INDEX.table_label_dispatchPort') || '发运港口'"
        :items="dispatchPortOptions"
        @filter="(e) => (dispatchPortFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:destinationPortHeader>
      <filter-content
        :text="$l('INDEX.table_label_destinationPort') || '目的港口'"
        :items="destinationPortOptions"
        @filter="(e) => (destinationPortFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:deliveryDateHeader>
      <filter-content
        :text="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
        :items="deliveryDateOptions"
        @filter="(e) => (deliveryDateFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:shipmentDateHeader>
      <filter-content
        :text="$l('INDEX.order_form_batch_label_shipmentDate') || '客户交期'"
        :items="shipmentDateOptions"
        @filter="(e) => (shipmentDateFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:identifyGoodsNoHeader>
      <filter-content
        :text="$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号'"
        :items="identifyGoodsNoOptions"
        @filter="(e) => (identifyGoodsNoFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:executeScmHeader>
      <filter-content
        :text="$l('INDEX.table_label_execution_plant') || '执行工厂'"
        :items="executeScmNameOptions"
        @filter="(e) => (executeScmNameFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:settlementFactoryHeader>
      <filter-content
        :text="$l('INDEX.table_label_settlementFactoryName') || '结算工厂'"
        :items="settlementFactoryNameOptions"
        @filter="(e) => (settlementFactoryNameFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:orderExecuteTypeHeader>
      <filter-content
        :text="$l('INDEX.table_label_orderExecuteType') || '业务性质'"
        :items="orderExecuteTypeOptions"
        @filter="(e) => (orderExecuteTypeFilter = e)"
        submitFilterOnClose
      />
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [EditLoading, TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      v_tableData: [],
      contractNoFilter: [],
      deliveryTypeFilter: [],
      retailerPoFilter: [],
      importerPoFilter: [],
      orderGoodsItemNoFilter: [],
      dispatchPortFilter: [],
      destinationPortFilter: [],
      deliveryDateFilter: [],
      shipmentDateFilter: [],
      identifyGoodsNoFilter: [],
      executeScmNameFilter: [],
      settlementFactoryNameFilter: [],
      orderExecuteTypeFilter: [],
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = [...(e || [])]
      },
      immediate: true,
    },
    filterParams: {
      handler() {
        this.filterData()
      },
      deep: true,
    },
  },
  computed: {
    height() {
      return this.tableHeight - 30 < 500 ? 500 : this.tableHeight - 30
    },
    deliveryTypeOptions() {
      const data = this.tableData
      return Array.from(
        new Set(data.map((i) => i.v_deliveryType).filter(Boolean))
      )
    },
    contractNoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.contractNo)))
    },
    retailerPoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.retailerPo)))
    },
    importerPoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.importerPo)))
    },
    orderGoodsItemNoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.orderGoodsItemNo)))
    },
    dispatchPortOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.v_dispatchPort)))
    },
    destinationPortOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.v_destinationPort)))
    },
    deliveryDateOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.deliveryDate)))
    },
    shipmentDateOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.shipmentDate)))
    },
    identifyGoodsNoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.identifyGoodsNo)))
    },
    executeScmNameOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.executeScmName)))
    },
    settlementFactoryNameOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.settlementFactoryName)))
    },
    orderExecuteTypeOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.v_orderExecuteType)))
    },
    filterParams() {
      return {
        contractNoFilter: this.contractNoFilter || [],
        deliveryTypeFilter: this.deliveryTypeFilter || [],
        retailerPoFilter: this.retailerPoFilter || [],
        importerPoFilter: this.importerPoFilter || [],
        orderGoodsItemNoFilter: this.orderGoodsItemNoFilter || [],
        dispatchPortFilter: this.dispatchPortFilter || [],
        destinationPortFilter: this.destinationPortFilter || [],
        deliveryDateFilter: this.deliveryDateFilter || [],
        shipmentDateFilter: this.shipmentDateFilter || [],
        identifyGoodsNoFilter: this.identifyGoodsNoFilter || [],
        executeScmNameFilter: this.executeScmNameFilter || [],
        settlementFactoryNameFilter: this.settlementFactoryNameFilter || [],
        orderExecuteTypeFilter: this.orderExecuteTypeFilter || [],
      }
    },
  },
  methods: {
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
    },
    onEditClosed({ row }) {
      if (row.containerBoxQty > row.notInBoxQty) {
        this.$message.warning('入柜箱数不能大于待入柜箱数')
        row.containerBoxQty = row.notInBoxQty
      }
      if (!row.containerBoxQty) {
        row.containerBoxQty = 1
      }
      const data = this.$refs.table.getCheckboxRecords()
      if (!data) return

      const { shipmentBatchBoxCode } = row
      const findIndex = data.findIndex(
        (item) => item.shipmentBatchBoxCode === shipmentBatchBoxCode
      )
      if (findIndex >= 0) {
        this.$emit('checkboxChange', data)
      }
    },
    onCheckboxChange(e) {
      const { records } = e
      this.$emit('checkboxChange', records)
    },
    filterData() {
      const {
        contractNoFilter,
        deliveryTypeFilter,
        retailerPoFilter,
        importerPoFilter,
        orderGoodsItemNoFilter,
        dispatchPortFilter,
        destinationPortFilter,
        deliveryDateFilter,
        shipmentDateFilter,
        identifyGoodsNoFilter,
        executeScmNameFilter,
        settlementFactoryNameFilter,
        orderExecuteTypeFilter,
      } = this.filterParams
      let data = [...this.tableData]
      // 筛选出货方式
      if (deliveryTypeFilter && deliveryTypeFilter.length) {
        data = data.filter((i) => deliveryTypeFilter.includes(i.v_deliveryType))
      }
      // 1、筛选合同号
      if (contractNoFilter && contractNoFilter.length) {
        data = data.filter((i) => contractNoFilter.includes(i.contractNo))
      }
      // 2、筛选零售商PO
      if (retailerPoFilter && retailerPoFilter.length) {
        data = data.filter((i) => retailerPoFilter.includes(i.retailerPo))
      }
      // 3、筛选进口商PO
      if (importerPoFilter && importerPoFilter.length) {
        data = data.filter((i) => importerPoFilter.includes(i.importerPo))
      }
      if (orderGoodsItemNoFilter && orderGoodsItemNoFilter.length) {
        data = data.filter((i) => orderGoodsItemNoFilter.includes(i.orderGoodsItemNo))
      }
      //筛选发运港口
      if (dispatchPortFilter && dispatchPortFilter.length) {
        data = data.filter((i) => dispatchPortFilter.includes(i.v_dispatchPort))
      }
      //筛选目的港口
      if (destinationPortFilter && destinationPortFilter.length) {
        data = data.filter((i) =>
          destinationPortFilter.includes(i.v_destinationPort)
        )
      }
      //筛选出货日期
      if (deliveryDateFilter && deliveryDateFilter.length) {
        data = data.filter((i) => deliveryDateFilter.includes(i.deliveryDate))
      }
      //筛选客户交期
      if (shipmentDateFilter && shipmentDateFilter.length) {
        data = data.filter((i) => shipmentDateFilter.includes(i.shipmentDate))
      }
      //筛选产品识别编号
      if (identifyGoodsNoFilter && identifyGoodsNoFilter.length) {
        data = data.filter((i) =>
          identifyGoodsNoFilter.includes(i.identifyGoodsNo)
        )
      }
      //执行工厂
      if (executeScmNameFilter && executeScmNameFilter.length) {
        data = data.filter((i) =>
          executeScmNameFilter.includes(i.executeScmName)
        )
      }
      //结算工厂
      if (settlementFactoryNameFilter && settlementFactoryNameFilter.length) {
        data = data.filter((i) =>
          settlementFactoryNameFilter.includes(i.settlementFactoryName)
        )
      }
      //业务性质
      if (orderExecuteTypeFilter && orderExecuteTypeFilter.length) {
        data = data.filter((i) =>
          orderExecuteTypeFilter.includes(i.v_orderExecuteType)
        )
      }

      this.v_tableData = data
      this.clearCheckboxRow()
      this.$emit('checkboxChange', [])
    },
  },
}
</script>
